import { APIService } from '../../../lib/api/APIService';
import { API_CONFIG } from '../../../config/api';

class StudioCasesAPI extends APIService {
  async generateCase(formData) {
    return this.post('/api/studio-cases/generate-case', formData, {
      isFormData: true,
      timeout: 180000,
    });
  }

  async startCover(casePayload, promptOverride) {
    return this.post(
      '/api/studio-cases/cover/start',
      {
        case: casePayload,
        ...(promptOverride ? { prompt_override: promptOverride } : {}),
      },
      { timeout: 120000 }
    );
  }

  async coverPrompts(casePayload) {
    return this.post('/api/studio-cases/cover/prompts', { case: casePayload }, { timeout: 60000 });
  }

  async coverStatus(taskId) {
    return this.get(`/api/studio-cases/cover/status/${encodeURIComponent(taskId)}`, {
      timeout: 30000,
    });
  }

  async downloadCoverBlob(url) {
    const token = this.getAccessToken();
    const res = await fetch(`${API_CONFIG.baseURL}/api/studio-cases/cover/fetch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ url }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Download failed (${res.status})`);
    }
    return res.blob();
  }

  async titleSuggestions(casePayload) {
    return this.post('/api/studio-cases/title-suggestions', { case: casePayload }, { timeout: 60000 });
  }

  async loglineSuggestions(payload) {
    return this.post('/api/studio-cases/logline-suggestions', payload, { timeout: 60000 });
  }

  async downloadCoverBlobWithFilename(url, filename) {
    const token = this.getAccessToken();
    const res = await fetch(`${API_CONFIG.baseURL}/api/studio-cases/cover/fetch`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ url, ...(filename ? { filename } : {}) }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Download failed (${res.status})`);
    }
    return res.blob();
  }

  async publishCaseWithMedia(formData) {
    return this.post('/api/studio-cases/publish-case', formData, {
      isFormData: true,
      timeout: 300000,
    });
  }

  async enhanceExhibit(formData) {
    return this.post('/api/studio-cases/exhibit/enhance', formData, {
      isFormData: true,
      timeout: 120000,
    });
  }

  async downloadCaseBlob(casePayload, filename) {
    const token = this.getAccessToken();
    const res = await fetch(`${API_CONFIG.baseURL}/api/studio-cases/case/download`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        case: casePayload,
        ...(filename ? { filename } : {}),
      }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Download failed (${res.status})`);
    }
    return res.blob();
  }
}

export const studioCasesAPI = new StudioCasesAPI();
